import React from "react";
import { connect } from 'react-redux'
import {Link} from "react-router-dom";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

//Icons
import AddIcon from "@material-ui/icons/Add";
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import Fingerprint from "@material-ui/icons/Fingerprint";

// core components
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";

// @material-ui/core components
import LinearProgress from '@material-ui/core/LinearProgress';
// import InputLabel from "@material-ui/core/InputLabel";
import Table from "components/Table/Table.jsx";
import Checkbox from "components/Checkbox/Checkbox";
//Table actions
import Actions from 'views/Tables/Actions'

//Approve popUp
import ConfirmAlert from 'components/Alert/Confirm'
import ProgressAlert from 'components/Alert/Progress'
import SuccessAlert from 'components/Alert/Success'

//Styles
import tableStyles from "assets/jss/material-dashboard-pro-react/components/table";

import "assets/scss/custom/react-select.css";
import Select from 'react-select/lib/Async';

// Actions
import {
  ibAccountRulesFetch,
  ibAccountRuleRemove,
  setIbAccountRuleProfile,
  setIbAccountRuleIb
} from 'actions/ibAccountRules'

import {
  ibTreeFilter,
 } from 'actions/ibTrees'

import { 
  success,
  danger,
 } from 'actions/notification'

import {
    ibsFetchFilter,
    ibsFetchAll,
} from 'actions/ibs'

import {
  profilesFetchIbs,
  profilesFetchAllFilter,
} from 'actions/profiles'


const customStyles = {
  option: (provided, state) => ({
    ...provided,
    textAlign: 'left',
  }),
   /*control: () => ({
    // none of react-select's styles are passed to <Control />
    width: 250,
    borderBottom: '1px solid silver',
  }),*/
  singleValue: (provided, state) => {
    const opacity = state.isDisabled ? 0.5 : 1;
    const transition = 'opacity 300ms';

    return { ...provided, opacity, transition };
  }
}



class List extends React.Component {
  selected = []
  state = {
    action:false,
    actionAddEdit:'',
    listAll:[],
    list:[],
    selected: [],
    value: 0,
    profileList: [],
    ibList: [],
    form:{
      profileId:false,
      ibId:false,
      parentIbId:false,
      percentage:0,
    }
  }

  constructor(props){
        super(props)
        this.state.value=props.value

    }

  componentDidMount(){

    this.props.ibsFetchAll().then(e=>{
      this.setState({
        ...this.state,
        ibList:e
      });
    });
    this.props.fetch().then(e=>this.filter());
  }

  //return select filter 
  filterSelect() {

    return ''; 
  }

  handleChange(event, name){
    this.setState(...this.state,{ [name]: event.profileId })
  }
  //on choose record
  select(id) {

    let select = []
    if (Array.isArray(id))
      select = (this.state.selected.length > 0)
        ? []
        : id
    else if (this.state.selected.indexOf(id) > -1)
      select = this.state.selected.filter((e) => e !== id)
    else
      select = this
        .state
        .selected
        .concat(id)
    this.setState({
      ...this.state,
      selected: select
    })
    
  }
  confirmDelete() {
    if(this.selected.length===0){
      this.props.fetch();
      this.setState({
        ...this.state,
        selected:[],
        alert: <SuccessAlert
          title={`Done!`}
          onConfirm={()=>{this.setState({...this.state,alert:false});}}
        />
      });
      return false;
    }
    this.setState({
      ...this.state,
      alert: <ProgressAlert
      value={100-((this.selected.length*100)/this.state.selected.length)}
      title={`Delete IB Account Rules (${this.state.selected.length-this.selected.length+'/'+this.state.selected.length})`}
      />
    });

    //alert('confirmDelete');
    this.props.remove(this.selected[0])
      .then((e)=>{
        this.selected=this.selected.slice(1);
        this.props.fetch().then(e=>this.filter());
        this.confirmDelete();
      })
  }
  delete() {
    // confirm()
    this.setState({
      ...this.state,
      alert: <ConfirmAlert
        text={`You want to delete user with id ${this.state.selected[0]}`}
        onCancel={()=>this.setState({...this.state,alert:false})}
        onConfirm={()=>{
          this.selected=this.state.selected.slice(0);
          this.confirmDelete();
        }}
      />
    });
  }
  
  filter(){
    // if (typeof this.props.profiles.list !== 'undefined') {
    //   this.filterProfiles();
    // } else{
    //   this.fetchProfiles()
      this.setState({
        ...this.state,
        selected: [],
        edit: false,
        list: this.props.ibAccountRules.list.content,
        listAll: this.props.ibAccountRules.list
      })
    // }
  }

  /*
  * onChange select options
  */
  selectProfileChange = ({value, label}) =>{

    if (value!==0) {
      this.setState({...this.state, profileId: value,profileNameSelected: {value, label},ibNameSelected: {value:'', label:'Ibs'}})
      this.props.setIbAccountRuleProfile({profileId: value, profileName: label})
      this.props.filter({filter: {profileId: value}});
      this.props.fetch({profileId: value}).then(e=>this.filter())
    } else {
      this.props.fetch().then(e=>this.filter());
    }

  }

  /*
  * filter by name text
  */
  selectProfileHandleInputChange = (newValue) => {

    this.setState({...this.state, profileName: newValue})
    //this.setState({...this.state,profileId: newValue.profileId});
    return newValue;

  }
  
  /*
  * load select options
  */
  selectProfileLoadOptions = (inputValue, callback) => {

    return this.props.profilesFetchAll(inputValue,false)
        .then((r) => {
          
          this.setState({
            ...this.state,
            profileList:r.content
          });

          const allOption = {value: 0, label: 'All Profiles'}
          const options = r.content.map((i) => { return {value: i.profileId, label: `${i.name} (${i.profileId})`} })
          return [allOption].concat(options)
        }  
    );
  }

  /*
  
  selectIbChange = ({value, label}) =>{
    
    if (value!==0) {
    
      let { selectedProfileId} = this.props.ibTrees;

      this.setState({...this.state, ibNameSelected: {value, label}})
      
      this.props.filter({filter: {ibId: value}});
      this.props.fetch(value).then(e=>this.filter())
    
    }

  }

 
  selectIbHandleInputChange = (newValue) => {
    this.setState({...this.state, clientName: newValue})
    return newValue;
  }


  selectIbLoadOptions = (inputValue, callback) => {
    let { selectedProfileId} = this.props.ibTrees;
    
    // /if (selectedProfileId) {
      


      return this.props.ibsFetchAll()
          .then((r) => {
            console.log('r ibsFetchAll',r.content)
            const allOption = {value: 0, label: 'All Ibs'}
            const options = r.content.map((i) => {return {value: i.ibId, label: `${i.firstName} ${i.lastName} (${i.ibId})`}})
            return [allOption].concat(options)
          }  
      );

      

  }*/

  getIbsName(ibId,ibs){

    let ibName = '';

    ibs.forEach(i => {
      if  (i.ibId===ibId) {
        ibName =  i.name+' '+i.lastName+' ('+i.ibId+')';
      }
    })

    return ibName;
     
  }
  
  getProfilesName(profileId,profiles){

    let profileName = '';

    profiles.forEach(i => {
      if  (i.profileId===profileId) {
        profileName =  i.name+' ('+i.profileId+')';
      }
    })

    return profileName;
     
  }


selectIbLoadOptions = (inputValue, callback) => {

      this.props.filter({size: 1000000,sort:{nameLowerCase: 'asc'}})
      return this.props.ibsFetchFilter(inputValue,false)
          .then((r) => {
            const allOption = {value: 0, label: 'All Ibs'}
            const options = r.content.map((i) => {return {value: i.ibId, label: `${i.firstName} ${i.lastName} (${i.ibId})`}})
            return [allOption].concat(options)
          }  
      );

  }
  

  /*
  * onChange select options
  */
  selectIbChange = ({value, label}) =>{

    if (value!==0) {

      this.setState({...this.state, ibId: value,ibNameSelected: {value:value, label:label}})
      this.props.setIbAccountRuleIb({ibId: value, ibName: label})
      
      this.props.filter({filter: {ibId: value}});
      this.props.fetch({ibId: value}).then(e=>this.filter());

    } else {
      this.props.fetch().then(e=>this.filter());
    }

  }

  selectIbHandleInputChange = (newValue) => {

    this.setState({...this.state, ibName: newValue})
    //this.setState({...this.state,profileId: newValue.profileId});
    return newValue;

  }




  render() {
    const { match, ibAccountRules, permissions} = this.props;
    const {form,edit,selected,list,profileId,profileList,ibList}=this.state
      const leverages = {
          ANY            : {value : 'ANY', label : 'Any'},
          LEVERAGE_500_1 : {value : 'LEVERAGE_500_1', label : '500:1'},
          LEVERAGE_400_1 : {value : 'LEVERAGE_400_1', label : '400:1'},
          LEVERAGE_200_1 : {value : 'LEVERAGE_200_1', label : '200:1'},
          LEVERAGE_100_1 : {value : 'LEVERAGE_100_1', label : '100:1'},
          LEVERAGE_50_1  : {value : 'LEVERAGE_50_1', label : '50:1'},
          LEVERAGE_1_1   : {value : 'LEVERAGE_1_1', label : '1:1'}
      }

    return (
      <Card>
        {this.state.alert}
        {
        (!ibAccountRules.isFetching)?
        //Top actions (pgination/limit/add/remove/edit)
        <Actions
          onPagination={(page)=>this.filter({page:page-1})}
          limit={ibAccountRules.pageable.size}
          limitOptions={[10,100,200]}
          onLimitation={(page)=>this.filter({size:page})}
          pagination={ibAccountRules.pageable.totalPages>1?{
            pages:ibAccountRules.pageable.totalPages,
            current:ibAccountRules.pageable.page+1,
          }:false}
          // title={this.getTableTitle()}
          dark={selected.length>0}
          icon={<Fingerprint/>}
          title={this.filterSelect()}
          actions={{
          add: (selected.length===0)
            ? <Link to={`${match.path}/add/`}>
                <IconButton>
                  <AddIcon/>
                </IconButton>
              </Link>
            : '',
            delete: (selected.length>0) && this.props.permissions.includes('IB_ACCOUNT_RULES_DELETE')
              ? <IconButton onClick={this.delete.bind(this)}><DeleteIcon/></IconButton>
              : '',
            edit: (selected.length===1)
              ? <Link to={`${match.path}/${this.state.selected[0]}`}>
                  <IconButton>
                      <EditIcon/>
                  </IconButton>
                </Link>
              : ''
        }}/>:''}

        <CardBody>
          {/* If is fetching not display table*/}
          {//Main table
              ibAccountRules.isFetching?<LinearProgress/>:
              <div>
             
              <div style={{width: '100%',margin: '0 auto',display: 'block'}}>
                <div>
                  <div style={{minWidth:'200px',maxWidth:'250px', display:'inline-flex', border:'0px solid black', marginRight:'10px'}}>
                    <Select
                      className="react-select-inline"
                      styles={customStyles}
                      loadOptions={this.selectProfileLoadOptions}
                      defaultOptions
                      onInputChange={this.selectProfileHandleInputChange}
                      backspaceRemoves={true}
                      onChange={(e) => this.selectProfileChange(e)}
                      value={this.state.profileNameSelected || ''}
                      placeholder="Search Profiles..."
                    />
                  </div>
                  <div className="" style={{minWidth:'200px',maxWidth:'250px', display:'inline-flex', border:'0px solid black', marginRight:'10px'}}>
                    {/*<Select
                      className="react-select-inline"
                      styles={customStyles}
                      loadOptions={this.selectIbLoadOptions}
                      defaultOptions
                      onInputChange={this.selectIbHandleInputChange}
                      backspaceRemoves={true}
                      onChange={(e) => this.selectIbChange(e)}
                      value={this.state.ibNameSelected || ''}
                      placeholder="Search Ibs..."
                    />*/}

                    <Select
                      className="react-select-inline"
                      styles={customStyles}
                      loadOptions={this.selectIbLoadOptions}
                      defaultOptions
                      onInputChange={this.selectIbHandleInputChange}
                      backspaceRemoves={true}
                      onChange={(value) => this.selectIbChange(value)}
                      /*value={this.state.form.ibId}*/
                      value={this.state.ibNameSelected || ''}
                      placeholder="Search Ibs..."
                      inputId="ibId"
                      inputProps={{ 
                        id: 'ibId',
                        value: this.state.form.ibId
                      }}

                    />

                  </div>
                </div>

              <Table
                tableHeaderColor="primary"
                sort={ibAccountRules.pageable.sort}
                tableHead={{
                  checkbox: <Checkbox props = {{ onClick:()=>this.select(Object.keys(this.state.list)), checked:this.state.selected.length===Object.keys(this.state.list).length }}/>,
                  ibAccountRuleId: "#",
                  accountGroup: "Account Group",
                  profileId: "Profile",
                  ibId: "IB Details",
                  accountPlatform: "Platform",
                  accountType: "Type",
                  accountLeverage: "Leverage",
                  accountCurrency: "Currency"
                }}
                tableData={Object
                .keys(this.state.list)
                .map(e => [
                    <Checkbox props = {{ onClick:()=>this.select(this.state.list[e].ibAccountRuleId), checked:this.state.selected.indexOf(this.state.list[e].ibAccountRuleId)>-1 }}/>,
                    this.state.list[e].ibAccountRuleId,
                    this.state.list[e].accountGroup,
                    this.getProfilesName(this.state.list[e].profileId,profileList),
                    this.getIbsName(this.state.list[e].ibId,ibList),
                    this.state.list[e].accountPlatform === null ? 'Any' : this.state.list[e].accountPlatform,
                    this.state.list[e].accountType === null ? 'Any' : this.state.list[e].accountType,
                    this.state.list[e].accountLeverage === null ? 'Any' : leverages[this.state.list[e].accountLeverage].label,
                    this.state.list[e].accountCurrency === null ? 'Any' : this.state.list[e].accountCurrency ,
                ] )} /></div></div>
            }
        </CardBody>
      </Card>
    );
  }
}
const mapStateToProps = (state,props) => {
  return {
    ibList: state.ibs.list,
    ibAccountRules: state.ibAccountRules,
    permissions: state.auth.permissions
  
}}
const mapDispatchToProps = (dispatch) => ({
  profilesFetchAll: (profileName, loading) => dispatch(profilesFetchAllFilter(profileName, loading)),
  profilesFetchIbs: (profileId, loading) => dispatch(profilesFetchIbs(profileId, loading)),
  filter: (filter) => dispatch(ibTreeFilter(filter)),
  fetch: (filters) => dispatch(ibAccountRulesFetch(filters)),
  danger: (text,time) => dispatch(danger(text,time)),
  success: (text,time) => dispatch(success(text,time)),
  remove: (ibAccountRuleId) => dispatch(ibAccountRuleRemove(ibAccountRuleId)),
  ibsFetchFilter: (ibName) => dispatch(ibsFetchFilter(ibName)),
  ibsFetchAll: (ibName) => dispatch(ibsFetchAll(ibName)),
  setIbAccountRuleProfile: (data) => dispatch(setIbAccountRuleProfile(data)),
  setIbAccountRuleIb: (data) => dispatch(setIbAccountRuleIb(data)),
})
export default withStyles(tableStyles)(connect(mapStateToProps, mapDispatchToProps)(List));



// WEBPACK FOOTER //
// ./src/views/IbAccountRules/List.jsx